// removed by extract-text-webpack-plugin
module.exports = {"content-box":"OzmoqVPKSHJ4ttSzAZVN2","contentBox":"OzmoqVPKSHJ4ttSzAZVN2","content":"WLncGyufxc1575zRZm51R","contributors-list":"_3P88mQ2T7iJ4v6PRK4iQIH","contributorsList":"_3P88mQ2T7iJ4v6PRK4iQIH","footer":"_2eAJX02C-xtG9teGk8MmjI","footer-image":"_2Qe3se1NqGIWo4Q7NS8GK1","footerImage":"_2Qe3se1NqGIWo4Q7NS8GK1"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/imprintSources/impressum.css
// module id = 526
// module chunks = 0